<template>
  <div :class="elementClass" @click="click">
    <slot></slot>
  </div>
</template>

<script>
import { iconButtonClass } from "../prefix";
export default {
  props: {
    disabled: {
      default: false,
      type: Boolean,
    },
  },
  computed: {
    elementClass() {
      return iconButtonClass + (this.disabled ? " disabled" : "");
    },
  },
  methods: {
    click(e) {
      this.$emit("click", e);
    },
  },
};
</script>

<style lang="scss">
@import "../scss/import.scss";
$element: $prefix + "-icon-button";

#{$element} {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  padding: 13px;
  float: left;
  cursor: pointer;
  transition: all 0.2s $animation-deceleration-curve-timing-function;
  &:hover {
    background: rgba(white, 0.2);
  }

  &.disabled {
    opacity: 0.5;
    cursor: default;
    pointer-events: none;
  }

  &.dark {
    &:hover {
      background: rgba(black, 0.1);
    }
  }

  svg {
    width: 22px;
    height: 22px;
  }
}
</style>
